<app-header></app-header>
<div class="min-h-screen flex items-center justify-center bg-gray-100 p-4">
  <div class="bg-white rounded-lg shadow-lg p-5 w-full max-w-2xl text-center">
    <!-- Success Message -->
    <h1 class="text-3xl md:text-4xl font-extrabold text-green-600 mb-4 animate-fade-in-down">
      Your Expression of Interest (EoI) is submitted.
    </h1>
    <p class="text-lg text-gray-700 mb-8 animate-fade-in">
      Thank You for your submission. You can now download the response.
    </p>

    <!-- Download PDF Button -->
    <button (click)="downloadPdf()"
            class="btn btn-primary  mx-3">
      <i class="bi bi-file-earmark-pdf-fill"></i>  Download PDF
    </button>
    <!-- Return to Login Button -->
    <button (click)="returnToLogin()"
            class="btn btn-success">
      <i class="bi bi-arrow-left-circle"></i> Return to Home
    </button>
   


  </div>
</div>

<app-footer></app-footer>
